import { ISession } from 'lib/types/session';
import safeFetch from '../fetch';

export const getSession = async (dontRedirect?: boolean) =>
  safeFetch<ISession>('/auth/current', {}, { dontRedirect });
